<template>
    <modal name="check-email-auth-modal"
           :width="480"
           :height="300"
           :min-width="480"
           :min-height="300"
           :pivotX="0.5"
           :pivotY="0.5"
           :delay="100"
           @before-open="beforeOpen">
        <div class="FloatMenu md_overlay md_overlay_0 ">
            <div class="modal modal_0">
                <div class="md_content">
                    <div class="popup_title pb20">
                    </div>
                    <span class="md_close">
                        <img
                            src="/images/union.svg"
                            alt=""
                            @click="modalClose"
                        >
                    </span>
                    <div class="header_greeting_failed">{{$t('alert.sign_up_not_completed')}}</div>
                    <div class="txt_subscribe">{{$t('alert.we_sent_email')}}</div>
                    <div class="txt_subscribe"><strong>{{$t('alert.check_your_email')}}</strong></div>
                    <div class="txt_subscribe_resend">{{$t('alert.please_resend_btn')}}
                        <a @click="resend">{{$t('alert.resend')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </modal>

</template>

<script>
    import _API from '../../../api'

    export default {
        name: 'CheckEmailAuthModal',
        components: {},
        props: [''],
        data() {
            return {
                userEmail: ''
            }
        },
        methods: {
            modalClose: function (event) {
                this.$modal.hide('check-email-auth-modal');
                event?.stopPropagation();
                event?.preventDefault();
            },
            beforeOpen(event) {
                this.userEmail = event.params;
            },
            resend: function () {
                return new Promise((_resolve, reject) => {
                    _API.ACCOUNT.resendAuthEmail(this.userEmail)
                        .then(res => {
                            if (res.data.isSuccess && res.status === 200) {
                                this.$modal.show('common-alert-modal', {
                                  messageType:'short',
                                  message: 'alert.check_your_email'
                                });
                                this.modalClose();
                            }
                        })
                        .catch(e => {
                            reject(`[resendAuthEmail] ${e}`)
                        });
                });
            }
        }
    }
</script>
<style lang="scss">
    .v--modal-overlay[data-modal="check-email-auth-modal"] {
        .v--modal-box {
            box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
        }
        .md_overlay {
            background: none;
        }

        .md_content {
          height: 280px;
        }
    }

    .header_greeting_failed {
        margin: 0px auto 35px;
        color: #ef2424;
        font-size: 26px;
        font-weight: 100;
        line-height: 1.3;
    }

    .txt_subscribe {
        font-size: 16px;
        color: #27599f;
        line-height: 1.4;
        text-align: center;
    }

    .txt_subscribe_resend {
        text-align: center;
        margin-top: 30px;

        a {
            cursor: pointer;
            text-decoration: underline;
            color: #4e83e2;
        }

        a: hover {
            color: #666666;
        }
    }

</style>


